/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import { mapMutations } from 'vuex';

export default {

  props: {
    alert: {
      required: false,
      type: Object,
      default: {
        title: '',
        message: '',
        type: '',
      },
    },
    buttons: {
      required: true,
      type: Array,
      default: [
        {
          name: 'sample',
          text: 'Sample',
          action: () => {},
        },
      ],
    },
  },

  created() {
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * This method will be called when saving the form.
     */
    addMore() {
      this.closeModal();
      this.$router.push({
        name: 'products.create',
      });
    },
    /**
     * This method will be called when saving the form.
     */
    edit() {
      this.closeModal();
      this.$router.push({
        name: 'products.edit',
        params: {
          id: this.productId,
        },
      });
    },
    /**
     * This method will be called when saving the form.
     */
    gotoIndex() {
      this.closeModal();
      this.$router.push({
        name: 'products.index',
      });
    },

    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/actionButtonsPopup/actionButtonsPopup.js